import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import { BsModalRef } from "ngx-bootstrap/modal";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { UserService } from "../../../services/index";

@Component({
  selector: "modal-content",
  templateUrl: "./addEditUser.html",
})
export class AddEditUser {
  @Output() partyUpdateEvent = new EventEmitter();
  row: any;
  data: any;
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  widthList: any[];
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  mode: string;
  saveEvent: any;
  agentList: any;
  partyCodeList: any;
  isLoading: boolean = false;
  userTypeList = [{ type: "ADMIN" }, { type: "USER" }];
  statusList = [{ name: "ACTIVE" }, { name: "INACTIVE" }];
  @Input() userdata: any = [];
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private userService: UserService
  ) {}
  ngOnInit() {
    if (this.mode == "Add") {
      this.userdata.doj = this.datePipe.transform(new Date(), "yyyy-mm-dd");
    }
  }
  ngAfterViewInit() {
    setTimeout(() => {
      $("#username").focus();
    }, 100);
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  onSaveUser(): void {
    if (
      this.userdata.username == "" ||
      this.userdata.password == "" ||
      this.userdata.usertype == "" ||
      this.userdata.status == ""
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      let that = this;
      let params = Object.assign({}, this.userdata);
      params["doj"] = this.datePipe.transform(params["doj"], "yyyy-MM-dd");
      params["mobile"] = this.userdata.mobile || "";
      params["menuFinList"] = [];
      this.isLoading = true;
      this.userService
        .addUser(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (res.success) {
            that.userdata = {
              userid: "",
              username: "",
              password: "",
              fullname: "",
              address: "",
              phone: "",
              mobile: "",
              email: "",
              usertype: "",
              doj: "",
              status: "",
              designation: "",
            };

            that.bsModalRef.hide();
            that.partyUpdateEvent.emit();
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    }
  }

  UpdateUser(): void {
    if (
      this.userdata.username == "" ||
      this.userdata.password == "" ||
      this.userdata.usertype == "" ||
      this.userdata.status == ""
    ) {
      swal("Make sure that all the entries are given!");
    } else {
      let that = this;
      let params = Object.assign({}, this.userdata);
      params["doj"] = this.datePipe.transform(params["doj"], "yyyy-MM-dd");
      params["menuFinList"] = [];
      params["mobile"] = this.userdata.mobile || "";
      this.isLoading = true;
      this.userService
        .updateUser(params)
        .then(function (res: any) {
          that.isLoading = false;
          if (res.success) {
            that.userdata = {
              userid: "",
              username: "",
              password: "",
              fullname: "",
              address: "",
              phone: "",
              mobile: "",
              email: "",
              usertype: "",
              doj: "",
              status: "",
              designation: "",
            };

            that.bsModalRef.hide();
            that.partyUpdateEvent.emit();
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          } else {
            swal("ERROR", res.message, "error");
          }
        })
        .catch(function (error: any) {
          that.isLoading = false;
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
          //console.log(error);
        });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/User/addEditUser.ts